import React from 'react';
import './introvideo.css';
import '../App.css';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

function IntroVideo () {
    const message = {
        h1: "Manage your economy easily",
        p: "While eliminating waste. Save with Penny",
      };
      
      const [displayedMessageH1, setDisplayedMessageH1] = useState("");
      const [displayedMessageP1, setDisplayedMessageP1] = useState("");
      const [currentIndexH1, setCurrentIndexH1] = useState(0);
      const [currentIndexP, setCurrentIndexP] = useState(0);
  

  useEffect(() => {
    if (currentIndexH1 < message.h1.length) {
      const timeoutId = setTimeout(() => {
        setDisplayedMessageH1((prevMessage) => prevMessage + message.h1.charAt(currentIndexH1));
        setCurrentIndexH1(currentIndexH1 + 1);
      }, 50);
  
      return () => clearTimeout(timeoutId); // Cleanup the timeout on component unmount
    }
  }, [currentIndexH1, message.h1]);
  
  useEffect(() => {
    if (currentIndexH1 === message.h1.length && currentIndexP < message.p.length) {
      const timeoutId = setTimeout(() => {
        setDisplayedMessageP1((prevMessage) => prevMessage + message.p.charAt(currentIndexP));
        setCurrentIndexP(currentIndexP + 1);
      }, 50);
  
      return () => clearTimeout(timeoutId); // Cleanup the timeout on component unmount
    }
  }, [currentIndexH1, currentIndexP, message.h1, message.p]);

  // Reset the index when the message changes
  useEffect(() => {
    setCurrentIndexH1(0);
    setCurrentIndexP(0);
  }, [message.h1, message.p]);
    
        
    return (
        <div className='video-container'>
            <video src='/videos/videobla.mp4' autoPlay loop muted/>
           <div className='video-textbox'>
            <div className='video-textbox2'>
                <h1>{displayedMessageH1}</h1>
                <p>{displayedMessageP1}</p>
            </div>
            </div>
            <div className='video-btns'>
                <Link to='/download' className='video-button-link'>
                    <button className='video-app-button'>
                        Download the app <i className='far fa-play-circle'/>
                    </button>
                </Link>
            </div>
        </div>
        );
    };

  
export default IntroVideo;